import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { Link } from 'react-router-dom';

type ReactRouterLinkProps = ComponentPropsWithoutRef<typeof Link>;

export type RouterLinkProps = Omit<ReactRouterLinkProps, 'to'> & {
  to?: string;
  href?: string;
};

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(function RouterLink(
  { to, href, ...rest },
  ref
) {
  return <Link ref={ref} to={to ?? href ?? '/'} {...rest} />;
});
